import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-camera',
  templateUrl: './icon-camera.component.html',
  styles: []
})
export class IconCameraComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
